import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PcsFilterCriteria, PcsFilterCriteriaforHighlight } from '../models/PendingIntegeration';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class GraphqlService {
  private _baseUrl: string;
  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {
    this._baseUrl = "";
  }

  getWhatLinksHereContent(topicId: string, subTopicId: string, sectionId: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetWhatLinksHere?topicId=" + topicId + "&subTopicId=" + subTopicId + "&sectionId=" + sectionId);
  }

  setCookie(obj) {
    return this.http.get<any>(this._baseUrl + "/LoginPage/SetCookie?value=" + obj);
  }

  DownloadFromS3(filename: string) {
    let url = this._baseUrl + "/layoutComponents/DownloadFromS3?filename=" + filename;
    document.location.href = url;
  }

  getCookie() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetCookie");
  }
  getMaintenanceS3Url() {
    return this.http.get(this._baseUrl + "/termsAndConditions/GetMaintenanceS3Url", { responseType: 'text' });
  }

  getAdminAnalytics(dateRange) {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetAccountDetailsforAdmin?dateRange=" + dateRange);
  }

  getWhatLinksHereLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/WhatLinksHereLabels");
  }

  getGASBLink() {
    return this.http.get(this._baseUrl + "/layoutComponents/getFASBLink", { responseType: 'text' });
  }

  getNavPathTree(path: string) {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getNavPathTree?path=" + path);
  }

  getAICPALabels() {
    return this.http.get<any>(this._baseUrl + "/AICPA/GetAICPALabels");
  }

  getSupersededStandardsLabels() {
    return this.http.get<any>(this._baseUrl + "/AICPA/GetSupersededStandardsLabels");
  }

  getSupersededStandardsAccordionData() {
    return this.http.get<any>(this._baseUrl + "/AICPA/GetSupersededStandardsAccordionContent");
  }

  getLeftMenu(publicationId: string) {
    return this.http.get<any>(this._baseUrl + "/Publications/PublicationWithMap?publicationId=" + publicationId);
  }

  getPageData(pageHeader: any) {
    return this.http.post<any>(this._baseUrl + "/Publications/Page?publicationId", pageHeader);
  }

  getShowAllPageData(allPagesHeader: any) {
    return this.http.post<any>(this._baseUrl + "/Publications/ShowAllPages?allPagesHeaders", allPagesHeader);
  }

  getArchivePageData(publicationId: string, pageId: string) {
    return this.http.get<any>(this._baseUrl + "/Publications/ArchivePage?publicationId=" + publicationId + "&pageId=" + pageId);
  }

  getArchiveDetails(publicationId: string, pageId: string) {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/GetArchiveDetails?publicationId=" + publicationId + "&topicId=" + pageId);
  }
  getGlobalFooter() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/globalFooter");
  }

  getLeftNavigation() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/leftNavigation");
  }

  getGlobalLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/navigationLabels");
  }
  getXbrlLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/xbrllabels");
  }

  getLoginPageContent() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetProfessionViewContent");
  }

  getgeneralFeedbackDropdown() {
    return this.http.get<any>(this._baseUrl + "/Feedback/getgeneralFeedbackDropdown");
  }

  sentmailgeneralFeedback(obj: any) {
    return this.http.post<any>(this._baseUrl + "/Feedback/SendGeneralFeedbackMail", obj);
  }

  SaveToDynamics(obj: any) {
    return this.http.post<any>(this._baseUrl + "/Feedback/SaveToDynamics", obj);
  }

  getprovideFeedbackDropdown() {
    return this.http.get<any>(this._baseUrl + "/Feedback/getprovideFeedbackDropdown");
  }

  getUserLogo() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/leftNavUserLogo")
  }

  getBookmarkLogo() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/leftNavBookmarkLogo")
  }

  getTcBasicView() {
    return this.http.get<any>(this._baseUrl + "/termsAndConditions/tcBasicView")
  }

  getTcProfessionalView() {
    return this.http.get<any>(this._baseUrl + "/termsAndConditions/tcProfessionalView")
  }
  getPendingContentSystemLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/pendingcontent")
  }
  getConceptsStatementsLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/concepts-statements")
  }
  getConceptStatementsLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/conceptStatements")
  }
  getSearchLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/searchcomponent")
  }
  getTCPendingContentSystem() {
    return this.http.get<any>(this._baseUrl + "/termsAndConditions/tcPendingContentSystem")
  }

  getPCFillingStatus() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/pcfillingstatus")
  }
  getPCPeriodType() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/pcperiodtype")
  }
  getHelpComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/helpcomponent")
  }
  getAboutUsComponentLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/aboutuscomponent")
  }

  getHomePageLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/HomePageLabels");
  }

  getHomePageComponents() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/HomePageComponent");
  }
  getCopyrightLabel() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/copyrightlabel");
  }

  GetBreadcrumbSession(url: string) {
    if (url.charAt(0).toString() == "/") {
      return this.http.get<any>(this._baseUrl + "/layoutComponents/GetBreadcrumbSession?url=" + url.slice(1));
    }
    else {
      return this.http.get<any>(this._baseUrl + "/layoutComponents/GetBreadcrumbSession?url=" + url);
    }
  }

  GetGlossaryContent(term: string, alphabet: string, pageNumber: number) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetMasterGlossary?filterTerm=" + term + "&alphabet=" + alphabet + "&pageNumber=" + pageNumber);
  }
  GetMasterGLossaryAlphabetsfiltered(term: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetMasterGLossaryAlphabetsfiltered?filteredterm=" + term );
  }

  SendContactSupportMail(obj: any) {
    return this.http.post<any>(this._baseUrl + "/LoginPage/SendContactSupportMail", obj);
  }

  getContactSupportLabels() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetContactSupportLabels")
  }

  SetPendingContentAgreementSession(agreementValue: boolean) {
    return this.http.post<any>(this._baseUrl + "/LoginPage/SetPendingContentAgreementSession?agreementValue=" + agreementValue, "");
  }

  GetPendingContentAgreementSession() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/GetPendingContentAgreementSession")
  }

  GetPCSIntegratedFlag() {
    return this.http.get<any>(this._baseUrl + "/paragraphAction/GetPCSIntegratedFlag")
  }

  SetPCSIntegratedFlag(flag) {
    return this.http.post<any>(this._baseUrl + "/paragraphAction/SetPCSIntegratedFlag?Flag=" + flag, "")
  }

  getS3BucketPath() {
    return this.http.get(this._baseUrl + "/LoginPage/GetS3BucketPath", { responseType: 'text' });
  }

  getS3BucketImagePath() {
    return this.http.get(this._baseUrl + "/LayoutComponents/GetS3BucketImagePath", { responseType: 'text' });
  }

  GetFASBTaxonomyUrl() {
    return this.http.get(this._baseUrl + "/LayoutComponents/GetFASBTaxonomyUrl", { responseType: 'text' });
  }

  getS3BucketImageASCLogo() {
    return this.http.get(this._baseUrl + "/LoginPage/GetS3BucketImageASCLogo", { responseType: 'text' });
  }

  getS3BucketSitesImagePath() {
    return this.http.get(this._baseUrl + "/LayoutComponents/GetS3BucketSitesImagePath", { responseType: 'text' });
  }

  GetArchiveLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/ArchiveLabels")
  }

  GetPendingContent(pcsFilterCriteria: PcsFilterCriteria) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetPendingContent", pcsFilterCriteria);
  }
  GetPendingContentHighlight(pcsFilterCriteria: PcsFilterCriteriaforHighlight) {
    return this.http.post<any>(this._baseUrl + "/Publications/pendingContentHighlight", pcsFilterCriteria);
  }
  GetPendingContentMergeList(pubId: string, pageId: string) {
    return this.http.get<any>(this._baseUrl + "/Publications/pendingContentMergeList?pubId=" + pubId + "&pageId=" + pageId);
  }
  GetPendingContentMergeListforShowAllinOnePage(pageHeaderList: any[]) {
    return this.http.post<any>(this._baseUrl + "/Publications/pendingContentMergeListforShowAllinOnePage?pageData=", pageHeaderList);
  }
  GetXBRLList() {
    return this.http.get<any>(this._baseUrl + "/Publications/xbrlList");
  }

  getCrossReferenceLabel() {
    return this.http.get<any>(this._baseUrl + "/crossReference/crossReferenceLabel");
  }

  getCrossReferenceReport(SearchData: any) {
    return this.http.post<any>(this._baseUrl + "/crossReference/crossReferenceReport", SearchData);
  }
  getcrossReferenceFeatureLabel() {

    return this.http.get<any>(this._baseUrl + "/crossReference/crossreference-featurelabel");

  }
  getNoticetoConstituentslabels() {

    return this.http.get<any>(this._baseUrl + "/crossReference/notice-to-constituents");

  }

  GetPendingIntegrationSession() {
    return this.http.get<any>(this._baseUrl + "/paragraphAction/GetPCSIntegrationSession")
  }
  SetPendingIntegrationSession(SetPCSIntegrationSession, PCSIntegrated) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/SetPCSIntegrationSession?PCSIntegrated=" + PCSIntegrated, SetPCSIntegrationSession);
  }
  getStandardTypeAcronymslabels() {

    return this.http.get<any>(this._baseUrl + "/crossReference/standardtype-acronyms");
  }
  getPendingsystemContentFAQlabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/Pendingcontentsystem-FAQ");
  }

  getTop5ParagraphElasticSearch(searchTerm: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/Top5Pargarphs?searchTerm=" + searchTerm);
  }

  getTop5TopicsElasticSearch(searchTerm: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/Top5Topics?searchTerm=" + searchTerm);
  }

  getTop5OtherSourceElasticSearch(searchTerm: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/Top5OtherSources?searchTerm=" + searchTerm);
  }

  getTop5PdfElasticSearch(searchTerm: string, dataSize:number) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/Top5PdfSource?searchTerm=" + searchTerm + "&datasize=" + dataSize);
  }

  getAutoSuggestionsElasticSearch(searchTerm: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetAutoSuggestions?searchTerm=" + searchTerm);
  }

  GetParagraphElasticSearchReasult(elasticSearchCondition, pageNumber: number) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetParagraphSearchResult?pageNumber=" + pageNumber, elasticSearchCondition);
  }

  GetTopicAggregates(elasticSearchCondition) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetTopicAggregate", elasticSearchCondition);
  }

  GetTopicSearchResults(elasticSearchCondition, pageNumber: number) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetTopicSearchResult?pageNumber=" + pageNumber, elasticSearchCondition);
  }

  GetSubopicSearchResults(elasticSearchCondition) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetSubtopicSearchResult", elasticSearchCondition);
  }

  GetOtherSourceSearchResults(elasticSearchCondition, pageNumber: number) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetOtherSourcesSearchResult?pageNumber=" + pageNumber, elasticSearchCondition);
  }

  GetPdfSearchResults(elasticSearchCondition, pageNumber: number) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetPdfSearchRsult?pageNumber=" + pageNumber, elasticSearchCondition);
  }

  GetGlossarySearch(searchTerm: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetGlossarySearch?searchTerm=" + searchTerm);
  }

  GetArchiveList(url: string) {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/GetArchiveVersions?url=" + url)
  }
  getRelatedExposureDrafts() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getrelatedExposureDrafts");
  }
  getRelatedpropsedASU(topicId: string, subTopicId: string, sectionId: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetRelatedProposedASU?topicId=" + topicId + "&subTopicId=" + subTopicId + "&sectionId=" + sectionId);
  }

  getAllRelatedpropsedASU(asuHeader) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetAllRelatedProposedASU", asuHeader);
  }

  getHelp_Bookmarklabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_bookmarklabels");
  }

  getHelp_Annotationlabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_annotationslabels");
  }
  gethelparchivecontentLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_archivecontent");
  }
  gethelpbasisforconclusionLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_basisforconclusionLabels");
  }
  gethelpbrowsingLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_browsingLabels");
  }
  gethelpcrossreferenceLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_crossreferenceLabels");
  }
  gethelpfeedbackLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_feedbackLabels");
  }
  gethelpglossariesLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_glossariesLabels");
  }
  gethelpgotoLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_gotoLabels");
  }
  gethelpJACContentLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_JACContentLabels");
  }
  gethelppcsfaqLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_pcsfaqLabels");
  }
  gethelppendingcontentLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_pendingcontentLabels");
  }
  getAdminPageLabels() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/getAdminPageLabels");
  }
  gethelppcsLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_pcsLabels");
  }
  gethelpprintingLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_printingLabels");
  }
  getSearchingLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_SearchingLabels");
  }
  gethelpseccontentLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_seccontentLabels");
  }
  gethelpxbrlfeatureLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_xbrlfeatureLabels");
  }
  GetGlossaryAlphabetList() {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetMasterGlossaryAlphabetsList");
  }
  gethelpaboutthecodificationLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_aboutthecodificationLabels");
  }
  gethelpcopyandpasteLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_copyandpasteLabels");
  }
  gethelpLocationLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/gethelp_locationLabels");
  }
  getInlineGlossaryContent(glossaryId: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetInlineGlossary?glossaryTermId=" + glossaryId);
  }
  getElasticCrossReferenceReport(SearchData: any) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/crossReferenceReport", SearchData);
  }
  getElasticPendingTextData(transitionId: any) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetPendingTextData?transitionId=", transitionId);
  }
  getPageUrl(searchTerm: string) {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetPageUrl?searchTerm=" + searchTerm);
  }

  getEarlyAdoption(pcsFilterCriteria: PcsFilterCriteria) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetEarlyAdoption", pcsFilterCriteria);
  }

  getSpecialCase() {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetSpecialCase");
  }

  getIntegratedPendingContent(pcsFilterCriteria: PcsFilterCriteria) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetIntegratedPendingContent", pcsFilterCriteria);
  }
  getPendingContentStatusBasedOnProfile(pcsFilterCriteria: PcsFilterCriteria) {
    return this.http.post<any>(this._baseUrl + "/ElasticSearch/GetPendingContentStatusBasedOnProfile", pcsFilterCriteria);
  }

  getwhatsnewherelinks() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/whatsnewhere");
  }
  GetCrossRefStandardType() {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetCrossRefStandardType");
  }

  GetMasterGlossarySearchResult(term: string, pageNumber: number, menu:string="") {
    return this.http.get<any>(this._baseUrl + "/ElasticSearch/GetMasterGlossarySearchResult?filterTerm=" + term + "&pageNumber=" + pageNumber + "&menu=" + menu);
  }

  setImageDimesionsToCache(imageDimensions: any) {
    return this.http.post(this._baseUrl + "/Publications/SetImageDimension?imageDimensions", imageDimensions, { responseType: 'text' });
  }

  getPreloadContentPage() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/GetPreloadContentPage");
  }

  getAnalyticsTrackingId() {
    return this.http.get(this._baseUrl + "/layoutComponents/getAnalyticsTrackingId", { responseType: 'text' });
  }

  getCryptionKeys() {
    return this.http.get(this._baseUrl + "/layoutComponents/getCryptionkeys", { responseType: 'text' });
  }
  getAnalyticsStatus() {
    return this.http.get(this._baseUrl + "/layoutComponents/getAnalyticsStatus", { responseType: 'text' });
  }
  getTaxonomyElementRefFileLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getTaxonomyElementRefFileLabels");
  }

  getRedisCacheLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getRedisCacheLabels");
  }
  clearRedisCache(application: string, environment: string, siteURL: string) {
    return this.http.get(this._baseUrl + "/layoutComponents/clearRedisCache?application=" + application + "&environment=" + environment + "&siteURL=" + siteURL, { responseType: 'text' });
  }
  getPDFBackupLandingPageLabels() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/getPDFBackupLandingPageLabels");
  }

  GetPDFBackupPageListAsync() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/GetPDFBackupPageList");
  }
  GetPDFBackupPageListForProViewAsync() {
    return this.http.get<any>(this._baseUrl + "/layoutComponents/GetPDFBackupPageListForProView");
  }
  getSiteKey() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/getSiteKey");
  }
}
